@if (verificationState === 'failed') {
  <ct-lib-info-banner type="warning">
    <p>{{ 'jobboard.platform.auth.verify-email.failed-message' | transloco }}</p>
  </ct-lib-info-banner>
} @else if (verificationState === 'success') {
  <ct-lib-info-banner type="success">
    <p>{{ 'jobboard.platform.auth.verify-email.success-message' | transloco }}</p>
  </ct-lib-info-banner>
} @else if (verificationState === 'pending') {
  <p>{{ 'jobboard.platform.auth.verify-email.title' | transloco }}</p>
} @else {
  <form [formGroup]="verifyEmailForm" (ngSubmit)="onVerifyEmailFormSubmit()">
    <div class="form-group" [class.invalid]="email.invalid && verifyEmailFormSubmitAttempt">
      <input
        class="form-control"
        type="email"
        [placeholder]="'jobboard.platform.auth.verify-email.email' | transloco"
        [formControl]="email"
      />
      <div class="validation">
        @if (email.errors?.['required']) {
          <p>{{ 'ct-library.validation.required' | transloco }}</p>
        }
        @if (email.errors?.['email'] || email.errors?.['pattern']) {
          <p>{{ 'ct-library.validation.email' | transloco }}</p>
        }
      </div>
    </div>
    <div class="form-group captcha-group" [class.invalid]="captchaCode.invalid && verifyEmailFormSubmitAttempt">
      <ct-lib-friendly-captcha
        [control]="captchaCode"
        [class.invalid]="verifyEmailFormSubmitAttempt && captchaCode.invalid"
        [startMode]="'auto'"
      />
    </div>
    <app-button htmlType="submit" [fullWidth]="true">
      {{ 'jobboard.platform.auth.verify-email.submit' | transloco }}
    </app-button>
  </form>
}
